export function Usuario (state) {
  return state.Usuario
}

export function Login (state) {
  return state.Login
}

export function Logged (state) {
  return state.EsLogged
}

export function PuedoCalcularPrecio (state) {
  try {
    let temp = state.Usuario.CalcularPrecio;
    if(!temp) return false;
    return temp;
  } catch (error) {
    return false;
  }   
}

export function TengoConfiguracion (state) {
  try {
    let temp = state.Usuario.AccesoServicioRapido;
    if(!temp) return false;
    return true;
  } catch (error) {
    return false;
  }
}

export function PuedoEditarConfiguracion(state) {
  try {
    let temp = state.Usuario.EditarConfiguracion;
    if(!temp) return false;
    return true;
  } catch (error) {
    return false;
  }
}
